<template>
  <div
    class="accordion"
    :class="{
      'accordion--mobile-only': mobileOnly
    }"
  >
    <button
      class="accordion__button"
      :aria-label="this.$t('global.accordion.aria.label', [this.id])"
      :class="{
        'accordion__button--mobile-only': mobileOnly,
        'accordion__button--open': isOpen && !showLoader
      }"
      @click.prevent="buttonClickHandler"
    >
      <span
        class="accordion__header"
        v-html="name"
      />
      <loader
        class="accordion__loader"
        v-if="showLoader"
      />
    </button>
    <div
      class="accordion__content"
      :class="{
        'accordion__content--mobile-only': mobileOnly,
        'open': isOpen
      }"
      ref="content"
    >
      <div
        class="accordion__content-inner"
        :class="{
          'html-teaser': isContentHtml
        }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import {breakpoints} from '../../variables/variables.js';
import pigeon from '../../utilities/js/pigeon/pigeon.js';
import Loader from "../loader/loader";

  export default {
    components: {
      Loader
    },
    props: {
      id: String,
      mobileOnly: {
        type: Boolean,
        default: false
      },
      initialOpen: {
        type: Boolean,
        default: false
      },
      initialShowLoader: {
        type: Boolean,
        default: false
      },
      isContentHtml: {
        type: Boolean,
        default: false
      },
      name: String
    },
    data() {
      return {
        isOpen: this.initialOpen,
        isMobile: window.innerWidth < breakpoints.tablet,
        initialLoaderVar: this.initialShowLoader,
        showLoader: false
      };
    },
    mounted() {
      window.addEventListener('breakpointChange', this.breakpointChangeHandler.bind(this));
      pigeon.subscribe(`show-loader:${this.id}`, this.handleLoader.bind(this));
    },
    created() {
      if (this.initialOpen) {
        setTimeout(() => {
          pigeon.publish('accordion:open', this.id);
        }, 300)
      }
    },
    methods: {
      buttonClickHandler() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      },
      open() {
        if (this.isOpen || (this.mobileOnly && !this.isMobile)) return;
        if (!this.initialLoaderVar) {
          this.isOpen = true;
        }
        pigeon.publish('accordion:open', this.id)
      },
      close() {
        if (!this.isOpen || (this.mobileOnly && !this.isMobile)) return;
        this.isOpen = false;
      },
      breakpointChangeHandler() {
        this.isMobile = window.innerWidth < breakpoints.tablet;
      },
      handleLoader(isVisible) {
        this.showLoader = isVisible;
        this.initialLoaderVar = isVisible;
        if (!isVisible) this.open();
      }
    }
  };

</script>
